import { PropsWithChildren, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

export type PortalProps = PropsWithChildren<{ selector: string }>

export const PortalRoot = ({ id = 'portal' }: { id?: string }) => {
  return <div id={id} className="static" />
}

export default function Portal({ children, selector }: PortalProps) {
  const ref = useRef<HTMLDivElement>(null!)
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    ref.current = document.querySelector(selector) as HTMLDivElement
    setMounted(true)
  }, [selector])

  return mounted ? createPortal(children, ref.current) : null
}
